import type { PropsWithChildren } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type FuuzeLinkProps = PropsWithChildren<
  {
    disabled?: boolean;
    showUnderline?: boolean;
  } & LinkProps
>;

export function FuuzeLink({ disabled, children, showUnderline, ...props }: FuuzeLinkProps) {
  return (
    <Link
      {...props}
      style={{
        textDecoration: showUnderline ? 'underline' : 'none',
        textUnderlineOffset: 1,
        // width: 'fit-content',
        ...props.style,
      }}
      onClick={e => {
        disabled && e.preventDefault();
        props?.onClick?.(e);
      }}
    >
      {children}
    </Link>
  );
}

export type FuuzeState = {
  hidePlayer?: boolean;
  search?: {
    focusSearchBar?: boolean;
    clear?: boolean;
  };
};
